import React from "react";
import { NavLink } from "react-router-dom";
import Local from "./Icons/Local";
import Tel from "./Icons/Tel";
import Mail from "./Icons/Mail";
import ToRight from "./Icons/ToRight";
import Insta from "./Icons/Insta";
import Facebook from "./Icons/Facebook";
import TikTok from "./Icons/TikTok";

const Footer = ({ sidebar }) => {
  return (
    <footer
      style={sidebar ? { filter: "blur(5px)", pointerEvents: "none" } : {}}
    >
      <div className="footerContainer">
        <div className="footer-top">
          <div className="coordonnees">
            <h2>Vialle Construction</h2>
            <p>
              Une entreprise de construction éco-performante située a
              Sainte-Adèle
            </p>
            <div className="location info">
              <Local />
              <p>2945 rue des Vers-luisant, J8B 2C9, Sainte-Adèle</p>
            </div>
            <div className="phone info">
              <Tel />
              <a href="tel:+14389908198">438-990-8198</a>
            </div>
            <div className="mail info">
              <Mail />
              <a href="mailto:vialleconstruction@gmail.com">
                vialleconstruction@gmail.com
              </a>
            </div>
          </div>
          <div className="services">
            <h2>Services</h2>
            <ul>
              <li>
                <NavLink to={"/Services"} className="lien-service">
                  <ToRight />
                  <p>Conception</p>
                </NavLink>
              </li>
              <li>
                <NavLink to={"/Services"} className="lien-service">
                  <ToRight />
                  <p>Construction</p>
                </NavLink>
              </li>
              <li>
                <NavLink to={"/Services"} className="lien-service">
                  <ToRight />
                  <p>Rénovation</p>
                </NavLink>
              </li>
            </ul>
          </div>
          <div className="partenaires">
            <NavLink to={"/Partenaires"}>
              <h2>Voir nos partenaires</h2>
            </NavLink>
          </div>
        </div>
        <div className="footer-bottom">
          <ul className="reseaux">
            <li>
              <Insta />
            </li>
            <li>
              <Facebook />
            </li>
            <li>
              <TikTok />
            </li>
          </ul>
          <p>2025 Vialle Construction. Tous droits réservés</p>
          <p>
            Fait par{" "}
            <a
              href="https://github.com/Redge07"
              target="_blank"
              rel="noopener noreferrer"
            >
              Régis Mathon
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
